import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function advancedQueryApFunc(data) {
  return request({
    url: URL.act.sharedCenter.advancedQueryApUrl,
    method: 'post',
    data
  })
}

export function saveApFunc(data) {
  return request({
    url: URL.act.sharedCenter.saveApUrl,
    method: 'post',
    data
  })
}
export function updateSaveApFunc(data) {
  return request({
    url: URL.act.sharedCenter.updateSaveApUrl,
    method: 'post',
    data
  })
}

export function deleteApFunc(data) {
  return request({
    url: URL.act.sharedCenter.deleteApUrl,
    method: 'post',
    data
  })
}

export function apDetailFunc(params) {
  return request({
    url: URL.act.sharedCenter.apDetailUrl,
    method: 'get',
    params
  })
}

export function titleBankFunc(params) {
  return request({
    url: URL.act.sharedCenter.titleBankUrl,
    method: 'get',
    params
  })
}

